var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-field',{attrs:{"label":_vm.label}},[_c('b-autocomplete',{attrs:{"value":_vm.value,"data":_vm.dropdownElements,"placeholder":"Seleziona un elemento o descrivi","open-on-focus":"","icon":"caret-down"},on:{"input":_vm.updateData,"select":(option) => (_vm.selected = option)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }